const swiper = new Swiper('.swiper-container', {
  // loop: true,
  // slidesPerView: 5.5,
  slidesPerView: 'auto',
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
});